/* eslint-disable react/require-default-props */
import React from 'react';
import { useSelector } from 'react-redux';
import { Popover, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { FilterOutlined } from '@ant-design/icons';

import { safeExtractFromObject } from '../../helpers/helpers';

import OnTraccrButton from '../buttons/OnTraccrButton';
import Colors from '../../constants/Colors';

function CardGridFilterButton({
  filter,
  filterActive,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  let filterButtonType = filterActive ? 'back' : 'primary';
  if (hasRedesign) {
    filterButtonType = filterActive ? 'primary' : 'cancel';
  }

  if (!filter) return null;

  const baseStyle = { width: 32, height: 32 };
  const style = filterActive
    ? { ...baseStyle, backgroundColor: 'rgba(214, 233, 255, 0.7)', border: `1px solid ${Colors.BLUE_300}` }
    : baseStyle;

  return (
    <Tooltip title="Filter">
      <Popover trigger="click" placement="bottomRight" content={filter}>
        <OnTraccrButton
          title={hasRedesign ? '' : 'Filter'}
          icon={hasRedesign ? <FilterOutlined style={{ marginLeft: -7, color: Colors.GRAY_800 }} /> : undefined}
          type={filterButtonType}
          style={hasRedesign ? style : {}}
        />
      </Popover>
    </Tooltip>
  );
}

CardGridFilterButton.propTypes = {
  filter: PropTypes.node,
  filterActive: PropTypes.bool,
};

export default CardGridFilterButton;
